// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2BcPi","loaderOuter":"PageOverlayLoader_loaderOuter__2PfnH"};